import { toast } from "react-toastify";

export function handleApiError(error, defaultMessage = "Something went wrong") {
  console.error("API Error:", error);

  // Axios server error
  if (error.response) {
    const msg =
      error.response.data?.message ||
      error.response.data?.error ||
      defaultMessage;

    toast.error(msg);
    return;
  }

  // Network or unexpected error
  toast.error("Network error. Please try again.");
}
